<template>
  <div class="waste-type-form">
    <BForm @submit.prevent="handleSubmit">
      <!-- 種別名入力 -->
      <BFormGroup
        label="種別名"
        label-for="type-name-input"
        :state="getFieldState('typeName')"
        :invalid-feedback="errors.typeName"
        class="mb-3"
      >
        <BFormInput
          id="type-name-input"
          v-model="localTypeName"
          :state="getFieldState('typeName')"
          placeholder="種別名を入力してください"
          maxlength="20"
        />
      </BFormGroup>

      <!-- 説明文 -->
      <div class="form-info mb-3">
        <small class="text-muted">
          <i class="bi bi-info-circle me-1"></i>
          種別名は20文字以内で入力してください。重複はできません。
        </small>
      </div>
    </BForm>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { BForm, BFormGroup, BFormInput } from 'bootstrap-vue-next'

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      typeName: ''
    })
  },
  errors: {
    type: Object,
    default: () => ({})
  },
  isEdit: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'submit'])

// ローカルstate（BFormInputはv-modelで繋ぐ）
const localTypeName = ref(props.modelValue.typeName ?? '')

// 親からmodelValueが変わったとき（モーダル再オープン等）にローカルを同期
watch(() => props.modelValue.typeName, (newVal) => {
  if (newVal !== localTypeName.value) {
    localTypeName.value = newVal ?? ''
  }
})

// ローカルの変更を親に伝える
watch(localTypeName, (newVal) => {
  emit('update:modelValue', { ...props.modelValue, typeName: newVal })
})

const getFieldState = (fieldName) => {
  if (props.errors[fieldName]) {
    return false
  }
  if (fieldName === 'typeName' && localTypeName.value?.trim()) {
    return true
  }
  return null
}

const handleSubmit = () => {
  emit('submit')
}
</script>

<style scoped>
.waste-type-form {
  padding: 0;
}

.form-info {
  margin-top: 1rem;
}
</style>
